export const GO_TO_STEP = 'go_to_step';
export const NEXT_STEP = 'next_step';
export const PREV_STEP = 'prev_step';
export const REGISTER_STEP = 'register_step';
